import type { SlashMenuTooltip } from '../types';
import { CopyTooltip } from './copy';
import { DeleteTooltip } from './delete';
import { MoveDownTooltip } from './move-down';
import { MoveUpTooltip } from './move-up';
import { NowTooltip } from './now';
import { TodayTooltip } from './today';
import { TomorrowTooltip } from './tomorrow';
import { YesterdayTooltip } from './yesterday';

export const slashMenuToolTips: Record<string, SlashMenuTooltip> = {
  Today: {
    figure: TodayTooltip,
    caption: '今天',
  },

  Tomorrow: {
    figure: TomorrowTooltip,
    caption: '明天',
  },

  Yesterday: {
    figure: YesterdayTooltip,
    caption: '昨天',
  },

  Now: {
    figure: NowTooltip,
    caption: '现在',
  },

  'Move Up': {
    figure: MoveUpTooltip,
    caption: '向上移动',
  },

  'Move Down': {
    figure: MoveDownTooltip,
    caption: '向下移动',
  },

  Copy: {
    figure: CopyTooltip,
    caption: '复制 / 创建副本',
  },

  Delete: {
    figure: DeleteTooltip,
    caption: '删除',
  },
};
